import { Field, FieldProps } from "@rjsf/utils";
import React from "react";

export const TitleField: Field = (props: FieldProps) => {
  const { classNames, schema, uiSchema } = props;
  const options = uiSchema ? uiSchema["ui:options"] : undefined;

  const type = options && typeof options["type"] === "string" ? options["type"] : "";

  switch (type) {
    case "h1":
      return <h1 className={`form-title ${classNames ?? ""}`}>{schema.description}</h1>;
    case "h2":
      return <h2 className={`form-title ${classNames ?? ""}`}>{schema.description}</h2>;
    case "h3":
      return <h3 className={`form-title ${classNames ?? ""}`}>{schema.description}</h3>;
    case "h4":
      return <h4 className={`form-title ${classNames ?? ""}`}>{schema.description}</h4>;
    case "h5":
      return <h5 className={`form-title ${classNames ?? ""}`}>{schema.description}</h5>;
    default:
      return <h2 className={`form-title ${classNames ?? ""}`}>{schema.description}</h2>;
  }
};
